import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EMAIL } from '@util/regex';
import { MessageService } from 'primeng/api';

import { ImportLearnerAttributes } from '../add-learners-wizard.component';

@Component({
  selector: 'vnm-confirm-learners-table',
  templateUrl: './confirm-learners-table.component.html',
  styleUrls: ['./confirm-learners-table.component.scss']
})
export class ConfirmLearnersTableComponent implements OnChanges {
  @Input() learners: ImportLearnerAttributes[] = [];
  @Input() requireContactMethod = false;
  @Output() allLearnersRemoved = new EventEmitter();
  @Output() learnerUpdated = new EventEmitter();
  @Output() learnerRemoved = new EventEmitter();
  @Output() learnerMissingContact = new EventEmitter<number>();

  emailPattern = EMAIL;

  private editLearners: { [s: string]: ImportLearnerAttributes } = {};

  constructor(private translateService: TranslateService, private messageService: MessageService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.learners) {
      this.learners.forEach((learner) => {
        learner.missingContactInformation = !(learner.email || learner.mobileNumber);
        if (learner.missingContactInformation) {
          this.learnerMissingContact.emit(learner.index);
        }
      });
    }
  }

  onRowEditInit(learner: ImportLearnerAttributes) {
    this.editLearners[learner.index] = { ...learner };
  }

  onRowEditSave(learner: ImportLearnerAttributes) {
    if (learner.firstName && learner.lastName && this.validContactMethod(learner)) {
      this.messageService.add({
        severity: 'success',
        summary: this.translateService.instant('app.success.edited'),
        detail: this.translateService.instant('add-learners-wizard.edit-success')
      });
      this.learnerUpdated.emit(learner.index);
      learner.missingContactInformation = false;
      delete this.editLearners[learner.index];
    } else {
      this.learners[learner.index] = this.editLearners[learner.index];
      this.messageService.add({
        severity: 'error',
        summary: this.translateService.instant('app.failure.edited'),
        detail: this.translateService.instant('add-learners-wizard.edit-error')
      });
    }
  }

  onRowEditCancel(learner: ImportLearnerAttributes) {
    this.learners[learner.index] = this.editLearners[learner.index];
    delete this.editLearners[learner.index];
  }

  onRowRemove(learner: ImportLearnerAttributes) {
    for (let i = learner.index + 1; i < this.learners.length; i++) {
      this.learners[i].index -= 1;
    }
    this.learners.splice(learner.index, 1);
    this.learnerRemoved.emit(learner.index);
    if (this.learners.length === 0) {
      this.allLearnersRemoved.emit();
    }
  }

  validContactMethod({ email, mobileNumber }: { email?; mobileNumber? }) {
    if (this.requireContactMethod) {
      return !!(email || mobileNumber);
    } else {
      return true;
    }
  }
}
